module.exports = __webpack_public_path__ + "static/img/logo-white.dce0034a.png";